import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-left-icon-button',
  imports: [NgClass],
  templateUrl: './ln-left-icon-button.component.html',
  styleUrl: './ln-left-icon-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnLeftIconButtonComponent {
  @Input({ required: true }) class!: string;
  @Output() OnClick = new EventEmitter<void>();
  HandleClick() {
    this.OnClick.emit();
  }
}
